export default __webpack_public_path__ + "static/media/loader.4add8fe8.png";